import React from 'react'
import '../../scss/_about.scss'

export default function About() {
  return (
    <div className="page-content easybuy-about-page">
      <div className="container">
        <div className="easybuy-about-header text-center">
          <span className="easybuy-about-badge">
            <i className="la la-building"></i>
            Sobre nosotros
          </span>

          <h2>Conoce EasyBuy</h2>

          <p>
            Trabajamos para ofrecer una experiencia de compra sencilla,
            confiable y pensada para nuestros clientes.
          </p>
        </div>

        <div className="row">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="easybuy-about-card">
              <div className="easybuy-about-icon">
                <i className="la la-eye"></i>
              </div>

              <div>
                <h2>Nuestra Visión</h2>

                <p>
                  En nuestra empresa, buscamos ofrecer una experiencia de compra
                  única, brindando productos de calidad y un servicio
                  excepcional. Nos esforzamos por innovar constantemente y
                  adaptarnos a las necesidades de nuestros clientes.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="easybuy-about-card">
              <div className="easybuy-about-icon">
                <i className="la la-bullseye"></i>
              </div>

              <div>
                <h2>Nuestra Misión</h2>

                <p>
                  Nuestro compromiso es proporcionar a nuestros clientes una
                  amplia variedad de productos a precios competitivos,
                  garantizando confianza y satisfacción en cada compra.
                  Trabajamos día a día para mejorar nuestros procesos y ofrecer
                  un servicio de excelencia.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
